// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Doum7","icon":"styles_icon___xWuN","moreIcon":"styles_moreIcon__tzN8i","activeIcon":"styles_activeIcon__uDEdE"};